
const NewsletterSection = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-4">
          Stay Ahead of Global Commerce Trends
        </h2>
        <p className="text-xl text-teal-100 mb-8 max-w-3xl mx-auto">
          Get weekly insights, market updates, and actionable strategies delivered 
          directly to your inbox. Join 5,000+ business leaders who trust our expertise.
        </p>
        
        <div className="max-w-md mx-auto">
          <form className="flex flex-col sm:flex-row gap-4">
            <input 
              type="email"
              placeholder="Enter your email address"
              className="flex-1 px-4 py-3 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
              required
            />
            <button 
              type="submit"
              className="bg-white text-teal-600 hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Subscribe Now
            </button>
          </form>
        </div>
        
        <div className="mt-6 text-sm text-teal-100">
          <p>✓ Weekly global commerce insights  ✓ No spam, unsubscribe anytime  ✓ Exclusive content for subscribers</p>
        </div>
        
        <div className="mt-8 flex justify-center items-center gap-8 text-sm">
          <div className="flex items-center">
            <i className="ri-mail-line mr-2"></i>
            <span>5,000+ Subscribers</span>
          </div>
          <div className="flex items-center">
            <i className="ri-star-line mr-2"></i>
            <span>4.9/5 Rating</span>
          </div>
          <div className="flex items-center">
            <i className="ri-calendar-line mr-2"></i>
            <span>Weekly Delivery</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
